import FetchService from "./Shared/FetchService";
import VeteranTypeDomainService from "../Domain/VeteranType/VeteranType.service";
const BASE_URL = "/aviso/veteranType";
export default class VeteranTypeService {
    static getVeteranTypes(search = {}, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/getVeteranTypes", {
            ids: search.ids,
            names: search.names,
            query: search.query,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        }).then((result) => {
            var _a;
            return (Object.assign(Object.assign({}, result), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'type' implicitly has an 'any' type.
                data: (_a = result.data) === null || _a === void 0 ? void 0 : _a.map((type) => VeteranTypeDomainService.fromJSON(type)) }));
        });
    }
}
